import { ref } from 'vue';
import { BooleanResponse, Fetch } from '@/models';

const checked = ref(false);
const isAdmin = ref(false);
let pending: Promise<boolean> | null = null;

export const useAdminAccess = () => {
  const ensureAdminStatus = async (call: Fetch): Promise<boolean> => {
    if (checked.value) {
      return isAdmin.value;
    }
    if (pending) {
      return pending;
    }

    pending = (async () => {
      const response: BooleanResponse = await call('permission-check').post().json();
      isAdmin.value = !response.error.value;
      checked.value = true;
      pending = null;
      return isAdmin.value;
    })();

    return pending;
  };

  return {
    isAdmin,
    ensureAdminStatus,
  };
};
